<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Bill Approval System" name="description"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <div id="layout-wrapper">
      <NavigationBar/>

      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">
            <!-- Page Title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">BILL APPROVALS</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboard</a></li>
                      <li class="breadcrumb-item active">Bill Approvals</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main Card -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                    <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                      <h4 class="card-title text-capitalize mb-0">
                        Pending Bill Approvals
                      </h4>
                      <div class="d-flex align-items-center">
                        <span class="badge bg-warning text-dark font-size-16 px-3 py-2 me-3">
                          <i class="mdi mdi-clock-alert-outline me-1"></i>
                          {{billDetails.length}} Pending
                        </span>
                        <button @click="getBillsPaginate()" class="btn btn-primary" type="button">
                          <i class="mdi mdi-refresh me-1"></i> Refresh
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Filters Section -->
                  <div class="card-header bg-white pt-0 pr-0 p-0 border-bottom">
                    <div class="p-3">
                      <div class="row g-2 align-items-center">
                        <div class="col-md-3 col-sm-6">
                          <select class="form-select font-13px" v-model="subCounty" @change="getBillsPaginate()">
                            <option selected="" value="">All Sub Counties</option>
                            <option :key="index" :value="item" v-for="(item, index) in subCounties">
                              {{ item.subCountyName }}
                            </option>
                          </select>
                        </div>

                        <div class="col-md-3 col-sm-6">
                          <select class="form-select font-13px" v-model="ward" @change="getBillsPaginate()">
                            <option selected="" value="">All Wards</option>
                            <option :key="index" :value="item" v-for="(item, index) in wards">
                              {{ item.wardName }}
                            </option>
                          </select>
                        </div>

                        <div class="col-md-3 col-sm-6">
                          <label class="form-label mb-0 font-13px">From:</label>
                          <input v-model="dateFrom" class="form-control font-13px" placeholder="Start date" type="date">
                        </div>

                        <div class="col-md-3 col-sm-6">
                          <label class="form-label mb-0 font-13px">To:</label>
                          <input v-model="dateTo" class="form-control font-13px" placeholder="End date" type="date">
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Table Section -->
                  <div class="card-body">
                    <div class="table-responsive">
                      <table class="table align-middle table-hover contacts-table table-striped" id="datatable-buttons">
                        <thead class="table-light">
                        <tr class="table-dark">
                          <th class="text-nowrap" scope="col" style="width: 50px;">NO.</th>
                          <th class="text-nowrap" scope="col" style="min-width: 150px;">Bill No</th>
                          <th class="text-nowrap" scope="col" style="min-width: 250px;">Business Details</th>
                          <th class="text-nowrap" scope="col" style="min-width: 150px;">Location</th>
                          <th class="text-nowrap text-end" scope="col" style="width: 120px;">Amount</th>
                          <th class="text-nowrap" scope="col" style="width: 120px;">Created By</th>
                          <th class="text-nowrap" scope="col" style="width: 120px;">Date</th>
                          <th class="text-nowrap text-center" scope="col" style="width: 150px;">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr :key="index" v-for="(item, index) in billDetails">
                          <td class="text-nowrap">{{((currentPage - 1) * pageSize) + index + 1}}</td>
                          <td class="text-nowrap">
                            <div class="fw-semibold text-primary">{{maskBillNo(item.billNo)}}</div>
                            <small class="text-muted">{{item.incomeTypePrefix}}</small>
                          </td>
                          <td>
                            <div class="fw-semibold">{{item.customerName || item.description}}</div>
                            <small class="text-muted d-block">{{item.incomeTypeDescription}}</small>
                            <small class="text-muted">{{item.feeDescription}}</small>
                          </td>
                          <td>
                            <div>{{item.subCountyName}}</div>
                            <small class="text-muted">{{item.wardName}}</small>
                            <small v-if="item.zone" class="d-block text-muted">{{item.zone}}</small>
                          </td>
                          <td class="text-end">
                            <div class="fw-bold text-primary">{{formatPrice(item.detailAmount)}}</div>
                          </td>
                          <td class="text-nowrap">
                            <small>{{item.names}}</small>
                          </td>
                          <td class="text-nowrap">
                            <small>{{formatDateTime(item.dateCreated)}}</small>
                          </td>
                          <td class="text-center">
                            <button @click="viewBillDetails(item)"
                                    class="btn btn-info btn-sm me-1"
                                    data-bs-toggle="modal"
                                    data-bs-target="#billDetailModal"
                                    title="View Details">
                              <i class="mdi mdi-eye"></i>
                            </button>
                            <button @click="approveBill(item)"
                                    class="btn btn-success btn-sm"
                                    title="Approve">
                              <i class="mdi mdi-check-circle"></i>
                            </button>
                          </td>
                        </tr>
                        </tbody>
                        <tfoot class="table-dark">
                        <tr>
                          <th colspan="4" class="text-start">
                            {{billDetails.length}} Bills Pending Approval
                          </th>
                          <td class="text-end">
                            <div class="fw-bold">Total: {{totalDetailAmount}}</div>
                          </td>
                          <th colspan="3"></th>
                        </tr>
                        </tfoot>
                      </table>

                      <!-- Loading State -->
                      <div v-if="loading" class="card-body px-5 d-flex flex-column justify-items-center align-items-center text-center">
                        <div class="p-5 py-0 pt-3">
                          <div class="p-5">
                            <div class="spinner-border text-info m-1" role="status">
                              <span class="sr-only text-uppercase">Loading...</span>
                            </div>
                          </div>
                        </div>
                        <h4 class="text-uppercase">Loading Data</h4>
                        <p>Fetching pending approvals...</p>
                      </div>

                      <!-- No Results State -->
                      <div v-if="billDetails.length<1 && loading===false" class="card-body px-5 d-flex flex-column justify-items-center align-items-center text-center">
                        <div class="p-5 py-0 pt-3">
                          <img :src="'./assets/images/no-results.png'" class="img mb-4" alt="No pending approvals"/>
                        </div>
                        <h4>No Pending Approvals</h4>
                        <p>All bills have been approved or there are no bills matching your criteria.</p>
                      </div>
                    </div>
                  </div>

                  <!-- Pagination Footer -->
                  <div class="card-footer bg-white">
                    <nav aria-label="Page navigation" class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <span class="pr-3 pb-0 mb-0 font-13px"><span>Rows Per Page</span></span>
                        <select class="form-select w-auto font-13px" v-model="pageSize">
                          <option value="10">10 Rows</option>
                          <option value="25">25 Rows</option>
                          <option value="50">50 Rows</option>
                          <option value="100">100 Rows</option>
                        </select>
                      </div>

                      <ul class="pagination">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <a class="page-link" @click="prevPage">Previous</a>
                        </li>
                        <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page" class="page-item" :class="{ active: currentPage === page }">
                          <span v-if="page === '...'" class="page-link">{{ page }}</span>
                          <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <a class="page-link" @click="nextPage">Next</a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Bill Detail Modal -->
        <div class="modal fade" id="billDetailModal" tabindex="-1" aria-labelledby="billDetailModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header bg-warning">
                <div>
                  <h5 class="modal-title text-dark" id="billDetailModalLabel">
                    <i class="mdi mdi-file-document-outline me-2"></i>Bill Details - Pending Approval
                  </h5>
                  <small class="text-dark opacity-75">{{selectedBill.billNo}}</small>
                </div>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <div class="modal-body p-4">
                <!-- Warning Badge -->
                <div class="alert alert-warning d-flex align-items-center mb-4" role="alert">
                  <i class="mdi mdi-alert-outline font-size-20 me-3"></i>
                  <div>
                    <strong>Pending Approval</strong>
                    <p class="mb-0">This bill requires approval before it can be printed or paid.</p>
                  </div>
                </div>

                <!-- Bill Information Grid -->
                <div class="row mb-4">
                  <div class="col-md-6">
                    <div class="card border shadow-sm h-100">
                      <div class="card-body">
                        <h6 class="card-title text-muted text-uppercase mb-3">
                          <i class="mdi mdi-information me-2"></i>Bill Information
                        </h6>
                        <div class="mb-2">
                          <small class="text-muted">Bill Number:</small>
                          <div class="fw-semibold">{{maskBillNo(selectedBill.billNo)}}</div>
                        </div>
                        <div class="mb-2">
                          <small class="text-muted">Customer:</small>
                          <div class="fw-semibold">{{selectedBill.customerName || selectedBill.description}}</div>
                        </div>
                        <div class="mb-2">
                          <small class="text-muted">Phone:</small>
                          <div>{{maskPhoneNumber(selectedBill.customerPhoneNumber)}}</div>
                        </div>
                        <div class="mb-2">
                          <small class="text-muted">Amount:</small>
                          <div class="fw-bold text-primary">{{formatPrice(selectedBill.detailAmount)}}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="card border shadow-sm h-100">
                      <div class="card-body">
                        <h6 class="card-title text-muted text-uppercase mb-3">
                          <i class="mdi mdi-account me-2"></i>Created By
                        </h6>
                        <div class="mb-2">
                          <small class="text-muted">Officer Name:</small>
                          <div class="fw-semibold">{{selectedBill.names}}</div>
                        </div>
                        <div class="mb-2">
                          <small class="text-muted">ID Number:</small>
                          <div>{{selectedBill.idNo}}</div>
                        </div>
                        <div class="mb-2">
                          <small class="text-muted">Phone:</small>
                          <div>{{maskPhoneNumber(selectedBill.phoneNumber)}}</div>
                        </div>
                        <div class="mb-2">
                          <small class="text-muted">Date Created:</small>
                          <div>{{formatDateTime(selectedBill.dateCreated)}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Location Information -->
                <div class="card border shadow-sm mb-4">
                  <div class="card-body">
                    <h6 class="card-title text-muted text-uppercase mb-3">
                      <i class="mdi mdi-map-marker me-2"></i>Location
                    </h6>
                    <div class="row">
                      <div class="col-md-4">
                        <small class="text-muted">Sub County:</small>
                        <div class="fw-semibold">{{selectedBill.subCountyName}}</div>
                      </div>
                      <div class="col-md-4">
                        <small class="text-muted">Ward:</small>
                        <div class="fw-semibold">{{selectedBill.wardName}}</div>
                      </div>
                      <div class="col-md-4" v-if="selectedBill.zone">
                        <small class="text-muted">Zone:</small>
                        <div class="fw-semibold">{{selectedBill.zone}}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Service Details -->
                <div class="card border shadow-sm">
                  <div class="card-body">
                    <h6 class="card-title text-muted text-uppercase mb-3">
                      <i class="mdi mdi-file-document me-2"></i>Service Details
                    </h6>
                    <div class="mb-2">
                      <small class="text-muted">Income Type:</small>
                      <div class="fw-semibold">{{selectedBill.incomeTypeDescription}}</div>
                    </div>
                    <div class="mb-2">
                      <small class="text-muted">Fee Description:</small>
                      <div>{{selectedBill.feeDescription}}</div>
                    </div>
                    <div v-if="selectedBill.description">
                      <small class="text-muted">Additional Details:</small>
                      <div>{{selectedBill.description}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer bg-light">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                  <i class="mdi mdi-close me-1"></i> Close
                </button>
                <button type="button" class="btn btn-success" @click="approveBill(selectedBill)" data-bs-dismiss="modal">
                  <i class="mdi mdi-check-circle me-1"></i> Approve Bill
                </button>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end d-sm-block">
                  Developed by County
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import {authUrl, biller, execute, getRight} from "@/api";
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import moment from "moment";

export default {
  name: "BillApprovals",
  components: {NavigationBar},
  data() {
    return {
      loading: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      dateFrom: '',
      dateTo: '',
      message: '',

      billDetails: [],
      selectedBill: {},

      subCounties: [],
      wards: [],
      subCounty: {
        subCountyID: "",
        subCountyName: ""
      },
      ward: {
        wardID: "",
        wardName: ""
      },

      summary: {
        count: 0,
        total: 0
      }
    }
  },

  watch: {
    pageSize(newPageSize) {
      this.getBillsPaginate();
      const totalItems = this.summary.count;
      const newTotalPages = Math.ceil(totalItems / newPageSize);
      this.totalPages = newTotalPages;
      this.currentPage = 1;
    },

    subCounty: function() {
      this.getWards();
      this.getBillsPaginate();
    },

    ward: function() {
      this.getBillsPaginate();
    },

    dateFrom: function() {
      if (this.dateFrom && this.dateTo) {
        this.getBillsPaginate();
      }
    },

    dateTo: function() {
      if (this.dateFrom && this.dateTo) {
        this.getBillsPaginate();
      }
    }
  },

  computed: {
    totalDetailAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, bill) => sum + parseFloat(bill.detailAmount || 0), 0));
    }
  },

  mounted() {
    this.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
    this.dateTo = moment().format('YYYY-MM-DD');
    this.getSubCounties();
    this.getBillsPaginate();
    this.menuAccess();
  },

  methods: {
    getRight(type) {
      return getRight(type);
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Bill Approvals");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).then(() => {}).catch(() => {});
    },

    maskBillNo(billNo) {
      if (!billNo) return '';
      const prefix = billNo.substring(0, 4);
      const suffix = billNo.substring(billNo.length - 3);
      const masked = '*'.repeat(billNo.length - 7);
      return `${prefix}${masked}${suffix}`;
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') return input;
      const digits = input.replace(/\D/g, '');
      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }
      return input;
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num);
    },

    formatPrice(value) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    },

    formatDateTime(dateString) {
      if (!dateString) return '';
      return moment(dateString).format('DD MMM YYYY, hh:mm A');
    },

    gotTo(route) {
      router.push(route);
    },

    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) end = totalPages;
      }

      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) start = 1;
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) pages.unshift("...");
      if (end < totalPages) pages.push("...");

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getBillsPaginate();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getBillsPaginate();
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getBillsPaginate();
      }
    },

    getBillsPaginate() {
      this.billDetails.splice(0);
      this.loading = true;

      const data = new FormData();
      data.append("function", "getPendingBillsForApproval");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("subCountyID", this.subCounty.subCountyID || '');
      data.append("wardID", this.ward.wardID || '');

      execute(data, biller)
          .then((res) => {
            this.loading = false;
            this.summary.count = 0;
            this.summary.total = 0;

            if (res.data.success) {
              this.billDetails = res.data.data.billDetails || [];
              this.summary = res.data.data.summary || {count: 0, total: 0};
              this.totalPages = Math.ceil(this.summary.count / this.pageSize);
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = e.message;
          });
    },

    viewBillDetails(bill) {
      this.selectedBill = bill;
    },

    approveBill(bill) {
      if (!confirm(`Are you sure you want to approve bill ${bill.billNo}?\n\nThis will make the bill printable and allow payment processing.`)) {
        return;
      }

      this.loading = true;
      const data = new FormData();
      data.append("function", "approveBill");
      data.append("billNo", bill.billNo);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller)
          .then((res) => {
            this.loading = false;

            if (res.data.success) {
              alert(`Bill ${bill.billNo} has been approved successfully!`);

              // Auto-print the bill after approval
              this.printBill(bill.billNo);

              // Refresh the list
              this.getBillsPaginate();
            } else {
              alert(`Error: ${res.data.message}`);
            }
          })
          .catch((e) => {
            this.loading = false;
            alert(`Error: ${e.message}`);
          });
    },

    printBill(billNo) {
      // Store bill number in localStorage for print page
      localStorage['params'] = JSON.stringify({
        billNo: billNo
      });

      // Open print page in new tab
      const routeData = this.$router.resolve({name: 'bill'});
      window.open(routeData.href, '_blank');
    },

    getSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounty");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.subCounties = res.data.data.subCounties;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getWards() {
      this.wards = [];
      this.ward = { wardID: '', wardName: '' };

      if (!this.subCounty.subCountyID) return;

      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", this.subCounty.subCountyID);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.wards = res.data.data.wards;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    }
  }
}
</script>

<style scoped>
.table td, .table th {
  padding: 0.75rem;
  vertical-align: middle;
}

.font-13px {
  font-size: 13px;
}

.card {
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.badge {
  font-weight: 500;
  padding: 0.35rem 0.65rem;
}

.table-hover tbody tr:hover {
  background-color: rgba(255, 193, 7, 0.1);
}

@media print {
  .modal-header,
  .modal-footer {
    display: none;
  }
}
</style>